import {createAction} from '@reduxjs/toolkit';
import {NavigateFunction} from 'react-router';
import {CreateBeerStyleDto, GetBeerStylesDTO} from 'typescript/dto/beerStylesDto';
import {withPayloadType} from 'typescript/types/PayloadType';

import {beerStylesNamespace} from './beerStyleSlice';

const getBeerStylesACS = createAction(`${beerStylesNamespace}/getBeerStylesACS`, withPayloadType<GetBeerStylesDTO>());

const createBeerStyleACS = createAction(
  `${beerStylesNamespace}/createBeerStyleACS`,

  withPayloadType<{dto: CreateBeerStyleDto; navigate?: NavigateFunction}>(),
);

const updateBeerStyleACS = createAction(
  `${beerStylesNamespace}/updateBeerStyleACS`,
  withPayloadType<{style: CreateBeerStyleDto; id: string}>(),
);

export {getBeerStylesACS, createBeerStyleACS, updateBeerStyleACS};
